import { Routes } from "@angular/router";
import { LayoutComponent } from "app/shared/components/layout/layout.component";
import { MsalGuard } from '@azure/msal-angular';
import { AuditTemplateListComponent } from "./component/audit-template-list/audit-template-list.component";
import { AuditTemplateDetailsComponent } from "./component/audit-template-details/audit-template-details.component";
import { AuditTemplateAddComponent } from "./component/audit-template-add/audit-template-add.component";
import { AuditTemplateModulesComponent } from "./component/audit-template-modules/audit-template-modules.component";

export const AUDITTEMPLATE_ROUTES: Routes = [
    {
        path: 'audit-template',
        component: LayoutComponent,
        canActivate: [MsalGuard],
        children: [
            { path: '', component: AuditTemplateListComponent },
            { path: 'add', component: AuditTemplateAddComponent },
            { path: ':id', component: AuditTemplateDetailsComponent },
            { path: 'audit-template-modules/:id', component: AuditTemplateModulesComponent }
        ]
    }
];
